import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

const CancelVisitDialog = ({ visible, visit, cancelling, onHide, onConfirm }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');
    const isOffice = visit?.activityType === 'office';

    useEffect(() => {
        if (!visible) return;
        setReason('');
        setError('');
    }, [visible]);

    const handleConfirm = () => {
        if (!reason.trim()) {
            setError('Indica el motivo de cancelación.');
            return;
        }
        if (reason.trim().length > 500) {
            setError('Máximo 500 caracteres.');
            return;
        }
        onConfirm(reason.trim());
    };

    const footer = (
        <div className="flex flex-column sm:flex-row justify-content-end gap-2">
            <Button type="button" label="Volver" className="p-button-text" onClick={onHide} disabled={cancelling} />
            <Button type="button" label={isOffice ? 'Cancelar actividad' : 'Cancelar visita'} icon="pi pi-ban" className="p-button-warning" onClick={handleConfirm} loading={cancelling} disabled={cancelling} />
        </div>
    );

    return (
        <Dialog className="ventas-dialog" header={isOffice ? 'Cancelar tiempo de oficina' : 'Cancelar visita'} visible={visible} onHide={onHide} modal draggable={false} footer={footer} style={{ width: '34rem' }} breakpoints={{ '960px': '75vw', '640px': '96vw' }}>
            <p className="text-color-secondary mt-0">
                {isOffice
                    ? 'El bloque de oficina quedará en el historial como cancelado.'
                    : <>La actividad de <strong>{visit?.clientName || visit?.prospectName || visit?.areaName || 'este contacto'}</strong> quedará en el historial como cancelada.</>}
            </p>
            <label className="block font-medium mb-2">Motivo de cancelación</label>
            <InputTextarea value={reason} rows={4} maxLength={500} autoResize className="w-full" onChange={(event) => {
                setReason(event.target.value);
                setError('');
            }} />
            {error ? <small className="p-error block mt-1">{error}</small> : null}
        </Dialog>
    );
};

export default CancelVisitDialog;
